var map = {
	"./bach.jpg": 3685,
	"./beethoven.jpg": 5022,
	"./einstein.jpg": 6176,
	"./frank.jpg": 4949,
	"./grimm.jpg": 240,
	"./lagerfeld.jpg": 7226,
	"./merkel.jpg": 2769,
	"./nietzsche.jpg": 3928,
	"./schumacher.jpg": 427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;